export enum OttopilotWebhooksWorkspaceCapabilityAccessOperation {
    create = "fd18760a-5fa7-4789-82ce-a149b56c01d2",
    read = "6b032b60-e433-49d8-b6cf-3b400a4234d0",
    update = "3e1e5517-20e5-4696-aefe-3247f57e4ca2",
    delete = "8849050b-8ee5-469b-bb78-2bfa51986d0e",
}
